import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { map } from 'rxjs/operators';
import { newServiceDialogOpen } from './new-service-dialog.action';
import { FEATURE_NAME } from './new-service-dialog.constant';

@Injectable()
export class NewServiceDialogEffect {

  private _onNewServiceDialogOpen$ = createEffect(() => this._actions$.pipe(
    ofType(newServiceDialogOpen),
    map((data) => zefDialogOpen({
      key: FEATURE_NAME,
      meta: data
    }))
  ));

  constructor(private _actions$: Actions) { }
}
